// this hooks is used to change focus to the first product in the product list
// after pagination or clearing filters

import { useEffect, useRef } from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';

const useFocusFirstProduct = () => {
  const products = useContextSelector(CatalogContext, (v) => v.products);

  const triggerFocusRef = useRef(false);

  // This effect is used to focus on the first product after either clearing filters or changing pagination,
  // to support keyboard navigation.
  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (triggerFocusRef.current && products.length > 0) {
      // We use setTimeout to not interfere with the automatic scrolling behavior of the browser
      // when the product list updates.
      timeout = setTimeout(() => {
        const targetElement = document.getElementById(`product_id_${products[0].id}`);
        targetElement?.focus();
      }, 1000);
    }
    triggerFocusRef.current = false;

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [products]);

  const triggerFocusOnNextUpdate = () => {
    triggerFocusRef.current = true;
  };

  return triggerFocusOnNextUpdate;
};

export default useFocusFirstProduct;
